import { ConsentOptions } from 'react-hook-consent'

import {
  GOOGLE_ADS_ID,
  GOOGLE_TRACKING_ID,
  TWITTER_CONVERSION_ID,
} from './constants'

const twitterServiceCode = TWITTER_CONVERSION_ID
  ? `!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);},s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');twq('config','${TWITTER_CONVERSION_ID}');`
  : ``

export const consentOptions: ConsentOptions = {
  services: [
    {
      id: 'required',
      name: 'Required Cookies',
      description:
        'Essential cookies enable basic functions such as security, network management and accessibility. Regularly, these cookies are only used in response to an action you have taken, such as saving your decision regarding the use of non-essential cookies. You can disable them by changing your browser settings, but this could affect the way the website works. For more information, please see our Privacy Policy.',
      scripts: [],
      mandatory: true,
    },
    {
      id: 'g-tag-twitter',
      name: 'Google and Twitter Analytics',
      description:
        'Marketing cookies come from external advertising companies ("third-party cookies") and are used to collect information about the websites visited by the user. The purpose of this is to create and display target group-oriented content and advertising to the user.',
      scripts: [
        {
          id: 'external-script',
          src: `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_TRACKING_ID}`,
        },
        {
          id: 'inline-code',
          code: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              
              gtag('config', '${GOOGLE_TRACKING_ID}');
              gtag('config', '${GOOGLE_ADS_ID}');
              
              ${twitterServiceCode}
            `,
        },
      ],
    },
  ],
}
